/**
 * Класс для управления отображением категорий квестов.
 * Обрабатывает показ/скрытие категорий в зависимости от размера экрана и действий пользователя.
 */
export class QuestCategories {
  private items: NodeListOf<HTMLElement>
  private expandButton: HTMLElement | null
  private showAll: boolean = false
  private mediaQuery: MediaQueryList = window.matchMedia('(max-width: 767px)')

  /**
   * Создает экземпляр управления категориями квестов.
   * @param {HTMLElement} container - HTML-элемент контейнера с категориями
   */
  constructor(container: HTMLElement) {
    this.items = container.querySelectorAll('[data-categories-item]')
    this.expandButton = container.querySelector('[data-show-more]')

    this.init()
  }

  /**
   * Инициализирует обработчики событий и начальное состояние видимости категорий.
   * Подписывается на клик по кнопке "Показать всё" и изменения медиа-запроса.
   * @private
   */
  private init(): void {
    this.expandButton?.addEventListener('click', () => this.handleShowAll())

    this.checkMediaQuery()

    this.mediaQuery.addEventListener('change', this.checkMediaQuery)
  }

  /**
   * Обработчик изменения медиа-запроса.
   * Вызывает обновление видимости элементов при изменении размера экрана.
   * @private
   */
  private checkMediaQuery = (): void => {
    this.updateVisibility()
  }

  /**
   * Обновляет видимость элементов категорий в зависимости от размера экрана и состояния showAll.
   * На мобильных устройствах скрывает элементы после 5-го, если не активирован режим "показать всё".
   * Также управляет видимостью кнопки "Показать всё".
   * @private
   */
  private updateVisibility(): void {
    const isMobile = this.mediaQuery.matches

    this.items.forEach((item, index) => {
      item.classList.toggle(
        'is-hidden',
        isMobile && !this.showAll && index >= 5
      )
    })

    this.expandButton?.classList.toggle('is-hidden', this.showAll)
  }

  /**
   * Обработчик клика по кнопке "Показать всё".
   * Устанавливает флаг showAll и обновляет видимость всех категорий.
   * @private
   */
  private handleShowAll(): void {
    this.showAll = true
    this.updateVisibility()
  }
}
